export default {
  RemoveItem: 'Remove Item',
  RemoveSize: 'Remove Size',
  RemoveEmployee: 'Remove Employee',
  RemovColor: 'Remov Color',
  NewEmployeeAdd: 'New Employee Add',
  NewItemsAdd: 'New Items Add',
  NewColorAdd: 'New Color Add',
  FeaturSizeUpdate: 'Featur Size Update',
  FeaturColorUpdate: 'Featur Color Update',
  FeaturItemUpdate: 'Featur Item Update',
  NewSizeAdd: 'New Size Add',
  NewFeedbackCriterionAdd: 'New Feed back Criterion Add',

  Item: 'Item',
  Size: 'Size',
  Colors: 'Colors',
  colorCode: 'Color code',
  Color: 'Color',
  ColorName: 'Color Name',
  Description: 'Description',
  Employee: 'Employee',
  Order: 'Order',
  Opacity: 'Opacity',
  Enable: 'Enable',
  Disable: 'Disable',
  Image: 'Image',
  Slug: 'Slug',
  rgbCode: 'rgb code'
}
